import SvgIcon from '@mui/material/SvgIcon';
import { colors } from '@startengine/design-system.theme.main';
import PropTypes from 'prop-types';

export const CampaignIcon = ({ ...rest }) => (
  <SvgIcon {...rest} viewBox="0 0 36 36">
    <svg width="36" height="36" viewBox="0 0 36 36" fill="none">
      <circle cx="18" cy="18" r="18" fill="#F7F7F7" />
      <path
        d="M12 26.0004V22.0004"
        stroke="#999999"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M18 26.0004V16.0004"
        stroke="#999999"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M24 26.0004V10.0004"
        stroke="#01D1B8"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  </SvgIcon>
);

export const Amenities = ({ ...rest }) => {
  return (
    <SvgIcon {...rest} viewBox="0 0 36 36">
      <svg width="36" height="36" viewBox="0 0 36 36" fill="none">
        <path
          d="M18 8V12"
          stroke="#000E0B"
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M18 23.9999V27.9999"
          stroke="#000E0B"
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M10.9302 10.9298L13.7602 13.7598"
          stroke="#000E0B"
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M22.2402 22.24L25.0702 25.07"
          stroke="#000E0B"
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M8 18H12"
          stroke="#000E0B"
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M24 18H28"
          stroke="#000E0B"
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M10.9302 25.07L13.7602 22.24"
          stroke="#000E0B"
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M22.2402 13.7598L25.0702 10.9298"
          stroke="#000E0B"
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </svg>
    </SvgIcon>
  );
};

export const DownArrow = ({ ...rest }) => {
  return (
    <SvgIcon {...rest} viewBox="0 0 36 36">
      <svg width="36" height="36" viewBox="0 0 36 36" fill="none">
        <path
          d="M17.9998 11.2814V23.2814"
          stroke="#000E0B"
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M21.9998 20.71L17.9998 24.71L13.9998 20.71"
          stroke="#000E0B"
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </svg>
    </SvgIcon>
  );
};

export const Certificate = ({ ...rest }) => {
  return (
    <SvgIcon {...rest} viewBox="0 0 36 36">
      <svg width="36" height="36" viewBox="0 0 36 36" fill="none">
        <path
          d="M14 16.25C14 16.1119 14.1119 16 14.25 16H21.75C21.8881 16 22 16.1119 22 16.25V29.4703C22 29.6815 21.7542 29.7975 21.5911 29.6632L18.1589 26.8368C18.0666 26.7607 17.9334 26.7607 17.8411 26.8368L14.4089 29.6632C14.2458 29.7975 14 29.6815 14 29.4703V16.25Z"
          stroke="#000E0B"
          strokeWidth="2"
        />
        <circle cx="18" cy="15" r="9" fill="white" />
        <circle cx="17.9712" cy="14.9736" r="6" fill="white" stroke="#000E0B" strokeWidth="2" />
      </svg>
    </SvgIcon>
  );
};

export const VerticalDivider = ({ heightWithoutPixels = '100' }) => (
  <svg
    width="4"
    height="100%"
    viewBox={`0 0 3 ${heightWithoutPixels || '100'}`}
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <line
      x1="1.41638"
      y1="6px"
      x2="1.41637"
      y2="99.5%"
      stroke="#666666"
      strokeWidth="1.35474"
      strokeLinecap="round"
      strokeDasharray="0.5 8"
    />
  </svg>
);

VerticalDivider.propTypes = {
  heightWithoutPixels: PropTypes.string,
};

export const ExternalLinkIcon = ({ ...rest }) => {
  return (
    <SvgIcon {...rest} viewBox="0 0 21 21">
      <svg
        width="21"
        height="21"
        viewBox="0 0 21 21"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M15.75 11.375V16.625C15.75 17.0891 15.5656 17.5342 15.2374 17.8624C14.9092 18.1906 14.4641 18.375 14 18.375H4.375C3.91087 18.375 3.46575 18.1906 3.13756 17.8624C2.80937 17.5342 2.625 17.0891 2.625 16.625V7C2.625 6.53587 2.80937 6.09075 3.13756 5.76256C3.46575 5.43437 3.91087 5.25 4.375 5.25H9.625"
          stroke="#185C65"
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M13.125 2.625H18.375V7.875"
          stroke="#185C65"
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M8.75 12.25L18.375 2.625"
          stroke="#185C65"
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </svg>
    </SvgIcon>
  );
};

export const FilterIcon = ({ categorySelected, sortBySelected, ...rest }) => {
  return (
    <SvgIcon {...rest} viewBox="0 0 34 34">
      <svg width="34" height="34" viewBox="0 0 34 34" fill="none">
        <rect width="34" height="34" rx="17" fill="#EEEEEE" />
        <path
          d="M24.5556 12.8024C24.5556 14.1243 23.4673 15.2159 22.1001 15.2159C20.7328 15.2159 19.6445 14.1243 19.6445 12.8024C19.6445 11.4804 20.7328 10.3888 22.1001 10.3888C23.4673 10.3888 24.5556 11.4804 24.5556 12.8024Z"
          stroke={categorySelected || sortBySelected ? colors.SEDark : '#000E0B'}
          strokeWidth="1.88889"
          strokeLinecap="round"
          strokeLinejoin="round"
          fill={categorySelected || sortBySelected ? colors.SEDark : 'none'}
        />
        <path
          d="M9.44443 21.1976C9.44443 22.5196 10.5327 23.6112 11.9 23.6112C13.2672 23.6112 14.3555 22.5196 14.3555 21.1976C14.3555 19.8757 13.2672 18.784 11.9 18.784C10.5327 18.784 9.44443 19.8757 9.44443 21.1976Z"
          stroke={categorySelected || sortBySelected ? colors.SEDark : '#000E0B'}
          strokeWidth="1.88889"
          strokeLinecap="round"
          strokeLinejoin="round"
          fill={categorySelected || sortBySelected ? colors.SEDark : 'none'}
        />
        <line
          x1="15.2056"
          y1="12.9073"
          x2="9.44446"
          y2="12.9073"
          stroke={categorySelected || sortBySelected ? colors.SEDark : '#000E0B'}
          strokeWidth="1.88889"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <line
          x1="0.944444"
          y1="-0.944444"
          x2="6.70556"
          y2="-0.944444"
          transform="matrix(1 -8.63435e-08 -8.85156e-08 -1 17.85 20.3582)"
          stroke={categorySelected || sortBySelected ? colors.SEDark : '#000E0B'}
          strokeWidth="1.88889"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </svg>
    </SvgIcon>
  );
};
